import { useRoleLabel } from '~/shell/auth/useRoleLabel'

import styles from './CustomerCluster.module.css'
import { HospitalPicker } from './HospitalPicker'
import { UserMenu } from './UserMenu'

/**
 * The header's top-right identity area: customer, role, and the user menu.
 */
export const CustomerCluster = () => {
  const roleLabel = useRoleLabel()

  return (
    <div className={styles.cluster}>
      <span className={styles.identity}>
        <HospitalPicker />
        <span className={styles.clusterDot}>·</span>
        <span className={styles.roleLabel}>{roleLabel}</span>
      </span>
      <UserMenu />
    </div>
  )
}
